export enum PinTypeEnum {
  LABEL = 1,
  DOT = 2,
  PIN = 3,
  PIN_LABEL = 4
}



// WEBPACK FOOTER //
// ./src/app/enums/PinTypeEnum.ts